module.exports = __webpack_public_path__ + "img/aidt-logo.a2948f36.jpg";